module.exports = __webpack_public_path__ + "static/media/growbeds.76724b44.jpg";